import React from 'react';
import { Route } from 'react-router-dom';
import { InventoryPage } from './InventoryPage';

export const routes = [<Route key="0" path="/inventory" component={InventoryPage} />];

export const navigation = [{ name: 'Inventering', link: '/inventory', icon: 'Inventory' }];
